import { Spinner, VStack } from "@chakra-ui/react"

export const LoadingPage = () => {
    return <VStack minH={'100vh'} w={'100vh'} justifyContent={'center'} alignItems={'center'}>
        <Spinner size={'lg'} color="white"/>
    </VStack>
}